import { render, staticRenderFns } from "./TabsStruktural.vue?vue&type=template&id=7119f882&scoped=true&"
import script from "./TabsStruktural.vue?vue&type=script&lang=js&"
export * from "./TabsStruktural.vue?vue&type=script&lang=js&"
import style0 from "./TabsStruktural.vue?vue&type=style&index=0&id=7119f882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119f882",
  null
  
)

export default component.exports